// extracted by mini-css-extract-plugin
module.exports = {"postHero":"post-hero_postHero__HObtL","content":"post-hero_content__j8ztS","btnMore":"post-hero_btnMore__zn7qx"};